import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', subject: '', message: '' });
      } else {
        const data = await response.json();
        setStatus(data.detail || 'Failed to send message');
      }
    } catch (error) {
      setStatus('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="contact-page" data-testid="contact-page">
      <div className="container">
        {/* Header */}
        <div className="contact-header" data-testid="contact-header">
          <h1 className="contact-title" data-testid="contact-title">
            Get in Touch
          </h1>
          <p className="contact-description" data-testid="contact-description">
            Got questions, collaboration ideas, or just want to chat about gaming? 
            I'd love to hear from you!
          </p>
        </div>

        <div className="contact-content">
          {/* Contact Form */}
          <div className="contact-form-section glass-card" data-testid="contact-form-section">
            <h2 className="form-title">Send Me a Message</h2>
            <p className="form-subtitle">
              Whether it's for brand deals, collabs, or community questions – drop me a line!
            </p>

            <form onSubmit={handleSubmit} className="contact-form" data-testid="contact-form">
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  data-testid="contact-name"
                  placeholder="Your name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  data-testid="contact-email"
                  placeholder="your.email@example.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  data-testid="contact-subject"
                  placeholder="What's this about?"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  disabled={loading}
                  rows="6"
                  data-testid="contact-message"
                  placeholder="Tell me more..."
                />
              </div>

              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={loading}
                data-testid="contact-submit"
              >
                {loading ? 'Sending...' : 'Send Message'}
              </button>

              {status && (
                <div 
                  className={`status-message ${status === 'success' ? 'success' : 'error'}`}
                  data-testid="contact-status"
                >
                  {status === 'success' 
                    ? '✅ Message sent successfully! I\'ll get back to you soon.'
                    : `⚠️ ${status}`
                  }
                </div>
              )}
            </form>
          </div>

          {/* Contact Info */}
          <div className="contact-info-section" data-testid="contact-info-section">
            <div className="contact-info-card glass-card">
              <h3>Why Reach Out?</h3>
              <ul className="contact-reasons">
                <li>🤝 Brand partnerships & sponsorships</li>
                <li>🎥 Content collaborations</li>
                <li>💬 Community questions</li>
                <li>📧 Press inquiries</li>
                <li>🎮 Gaming tips & suggestions</li>
              </ul>
            </div>

            <div className="social-info-card glass-card">
              <h3>Connect on Social</h3>
              <p>Follow me for daily updates and behind-the-scenes content:</p>
              <div className="social-links-list">
                <a 
                  href="https://youtube.com/@clutchbabe9?si=IVZiXzIxZMTc2y5t" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link-item"
                  data-testid="social-youtube-link"
                >
                  <span className="social-icon">📺</span>
                  YouTube
                </a>
                <a 
                  href="https://www.instagram.com/clutchbabe9?igsh=ZWN3MzByMW02djUz" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link-item"
                  data-testid="social-instagram-link"
                >
                  <span className="social-icon">📸</span>
                  Instagram
                </a>
                <a 
                  href="https://web.gameram.com/profile/ClutchBabe9" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link-item"
                  data-testid="social-gameram-link"
                >
                  <span className="social-icon">🎮</span>
                  Gameram
                </a>
                <a 
                  href="https://bsky.app/profile/clutchbabe9.bsky.social" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link-item"
                  data-testid="social-bluesky-link"
                >
                  <span className="social-icon">☁️</span>
                  Bluesky
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Contact;
